let Util = {
    groupBy(list, getGroupKey){
        return list.reduce((grouped, item)=>{
            let key = getGroupKey(item);
            (grouped[key] = grouped[key] || []).push(item);
            return grouped
        }, {})
    },

    groupByDate(list, key){
        return this.groupBy(list, (item=> window.moment(item[key]).format("DD MMMM YYYY")))
    },

    groupByKey(list, key){
        return this.groupBy(list, (item=> item[key]))
    },

    isPaginated(data){
        return Object.prototype.hasOwnProperty.call(data, 'current_page');
    },

    getData(response){
        return this.isPaginated(response) ? response.data : response;
    },
};

export default Util;